export default "__VITE_ASSET__CCmIVCqr__"